import { ADMIN as BASE } from "..";

export const ADMIN_USERS = BASE.child("/adminUsers");
export const ADMIN_USER = ADMIN_USERS.sub("/:adminUserId");
